import { EN, EN_AU, EN_IN, EN_SG, EN_UK, EN_US } from './languageCode';

export const languagesWithDotInNumber = [EN, EN_AU, EN_IN, EN_SG, EN_UK, EN_US];
